var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-iconstack',{staticClass:"tile-monument",class:_vm.monumentClass,style:(_vm.monumentStyle)},[_c('b-icon',{class:_vm.primaryTileClass,attrs:{"stacked":"","icon":"octagon-fill"}}),_c('b-icon',{class:_vm.secondaryTileClass,attrs:{"stacked":"","icon":"octagon-fill","scale":"0.4"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }